import { h } from "@stencil/core";
const getBlockerRect = (targetRect, side) => {
    if (targetRect === null || !getIsInViewport(targetRect)) {
        return null;
    }
    switch (side) {
        case "top":
            if (targetRect.bottom > 0 && targetRect.top < window.innerHeight) {
                return {
                    left: 0,
                    top: 0,
                    height: targetRect.top,
                    width: window.innerWidth
                };
            }
            break;
        case "bottom":
            if (targetRect.bottom > 0 && targetRect.top + targetRect.height < window.innerHeight) {
                return {
                    left: 0,
                    top: targetRect.top + targetRect.height,
                    height: window.innerHeight - (targetRect.top + targetRect.height),
                    width: window.innerWidth
                };
            }
            break;
        case "left":
            if (targetRect.left > 0) {
                return {
                    left: 0,
                    top: targetRect.top,
                    height: targetRect.height,
                    width: targetRect.left
                };
            }
            break;
        case "right":
            if (targetRect.right < window.innerWidth) {
                return {
                    left: targetRect.right,
                    top: targetRect.top,
                    height: targetRect.height,
                    width: window.innerWidth - targetRect.right
                };
            }
            break;
        default:
            break;
    }
    return null;
};
const getIsInViewport = (rect) => {
    return !(rect.bottom < 0 || rect.top > window.innerHeight);
};
const getBlockerStyle = (screenRect) => {
    return {
        top: `${screenRect.top}px`,
        left: `${screenRect.left}px`,
        width: `${screenRect.width}px`,
        height: `${screenRect.height}px`
    };
};
export const GuidedTourBackdrop = ({ targetRect = null }) => {
    const baseClass = "ux-guided-tour-backdrop";
    const isInViewport = targetRect !== null ? getIsInViewport(targetRect) : false;
    const blockers = {
        // @ts-expect-error Check for typing
        top: getBlockerRect(targetRect, "top"),
        // @ts-expect-error Check for typing
        bottom: getBlockerRect(targetRect, "bottom"),
        // @ts-expect-error Check for typing
        left: getBlockerRect(targetRect, "left"),
        // @ts-expect-error Check for typing
        right: getBlockerRect(targetRect, "right")
    };
    return (h("div", { class: {
            [baseClass]: true,
            [`${baseClass}--focus-rect`]: isInViewport
        } }, blockers.top !== null && (h("div", { class: {
            [`${baseClass}__blocker`]: true,
            [`${baseClass}__blocker--top`]: true
        }, style: getBlockerStyle(blockers.top) })), blockers.bottom !== null && (h("div", { class: {
            [`${baseClass}__blocker`]: true,
            [`${baseClass}__blocker--bottom`]: true
        }, style: getBlockerStyle(blockers.bottom) })), blockers.left !== null && (h("div", { class: {
            [`${baseClass}__blocker`]: true,
            [`${baseClass}__blocker--left`]: true
        }, style: getBlockerStyle(blockers.left) })), blockers.right !== null && (h("div", { class: {
            [`${baseClass}__blocker`]: true,
            [`${baseClass}__blocker--right`]: true
        }, style: getBlockerStyle(blockers.right) }))));
};
export default GuidedTourBackdrop;
//# sourceMappingURL=guided-tour-backdrop.js.map
